<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script src="http://192.168.2.225:8081/target/target-script-min.js#anonymous"></script>
<script>
export default {
  name: 'App',
    mounted() {
    if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
        this.$router.replace('/m_index');
    } else {
        if(this.$route.path == '/backstage'){
            this.$router.replace('/backstage');
        }else{
            this.$router.replace('/pc_index');
        }
    }

  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue